import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../config/reduxIndex";
import moment from 'moment-timezone';
import EditLead from '../../components/leadtracker/EditLead';

class EditLeadContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activityCode: null,
			bpCardCode: null,
			bpContactCode: null,
			//status: 'due',
			complete: 'N',
			companyName: '',
			contactFirstName: '',
			contactLastName: '',
			contactPhone: '',
			contactEmail: '',
			contactNotes: 'wants to',
			actionItem: '',
			details: '',
			enteredDate: null,
			lastContactDate: null,
			dueDate: null
		}
	}

	componentDidMount() {
		const { enteredDate } = this.state;
		const { editLead } = this.props.leadData;
		if (enteredDate === null) {
			this.setState({
				...editLead,
				enteredDate: moment().format('YYYY-MM-DD')
			})
		}
	}

	render() {

		const leadDateProps = {
			enteredDate: this.state.enteredDate,
			lastContactDate: this.state.lastContactDate,
			dueDate: this.state.dueDate,
			onChange: this.onChange
		}

		return (
			<EditLead
				{...this.state}
				leadDateProps={leadDateProps}
				goBack={this.goBack}
				setComplete={this.setComplete}
				setIncomplete={this.setIncomplete}
				onChange={this.onChange} // TODO RMV? this is used in date props too
				save={this.save}
			/>

		);
	}

	onChange = (value, attr) => {
		this.setState({
			[attr]: value
		})
	}

	goBack = () => {
		this.props.gotoMode('search');
	}

	setComplete = () => {
		this.setState({
			complete: 'Y'
		})
	}

	setIncomplete = () => {
		this.setState({
			complete: 'N'
		})
	}

	onChange = (value, attr) => {
		this.setState({
			[attr]: value
		})
	}

	save = () => {
		this.props.updateExistingLead({ ...this.state });
		this.goBack();
	}
}

const mapStateToProps = state => ({
	leadData: state.leadData
});

const mapDispatchToProps = dispatch => {
	return {
		updateExistingLead: (obj) => {
			dispatch(actions.leadData.updateExistingLead(obj))
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(EditLeadContainer);


// WEBPACK FOOTER //
// ./src/containers/leadtracker/EditLeadContainer.js